import { Button } from "antd";
import formatPrice from "../../../components/formatPrice";
import datetimeParser from "../../../components/datetimeParser";
import DownloadXML from "./DownloadXML";
const columns = [
	{
		title: "ID grupy",
		dataIndex: "msr_generated_groups_own_id",
		width: "150px",
		key: "msr_generated_groups_own_id",
		render: (item, record) => <div>#{item}</div>,
	},
	{
		title: "Liczba przelewów",
		dataIndex: "msr_generated_groups_transfers",
		width: "150px",
		key: "msr_generated_groups_transfers",
		render: (item, record) => (
			<div
				style={{
					fontSize: "14px",
					fontWeight: 600,
					textAlign: "right",
				}}
			>
				{record.transfers ? record.transfers.length : 0}
			</div>
		),
	},
	{
		title: "Kwota przelewu",
		dataIndex: "msr_transfers_amount",
		key: "msr_transfers_amount",
		width: "200px",
		render: (item, record) => (
			<div
				style={{
					fontSize: "14px",
					fontWeight: 700,
					textAlign: "right",
				}}
			>
				{formatPrice(
					record.transfers.reduce(
						(sum, przelew) =>
							sum + parseFloat(przelew.msr_transfers_amount),
						0,
					),
				)}{" "}
				zł
			</div>
		),
	},
	{
		title: "Wygenerowane przez",
		dataIndex: "msr_transfers_amount",
		key: "msr_transfers_amount",
		render: (item, record) => (
			<div style={{ fontSize: "14px", fontWeight: 600 }}>
				{record.userDetails.mlg_users_fullname}
			</div>
		),
	},
	{
		title: "Data wygenerowania",
		dataIndex: "msr_generated_groups_created_datetime",
		key: "msr_generated_groups_created_datetime",
		render: (item, record) => (
			<div style={{ fontSize: "14px", fontWeight: 500 }}>
				{datetimeParser(item, "YYYY-MM-DD HH:mm:ss")}
			</div>
		),
	},
	{
		title: "Pobierz XML",
		dataIndex: "msr_transfers_confirmed_datetime",
		key: "msr_transfers_confirmed_datetime",
		render: (item, record) =>
			record.msr_generated_files_id && (
				<DownloadXML
					fileName={record.msr_generated_files_name}
					generatedFileId={record.msr_generated_files_id}
					generatedGroupId={record.msr_generated_groups_id}
					isGroup
				/>
			),
	},
];

export default columns;
